module.exports = __webpack_public_path__ + "static/genasi-air-1-ec2c16788fee79e05a816032416fe96c.png";